// extracted by mini-css-extract-plugin
module.exports = {"CheckRuntimeModalH5":"R_CheckRuntimeModalH5__DMWuJ"};